import { breakpoints, mediaQueries, mq, multipliers, viewportsArray } from "./foundation/breakpoints";
import colors from "./foundation/colors";
import fonts from "./foundation/fonts";
import animation from "./foundation/animation";
import buttons from "./foundation/buttons";
import typography from "./foundation/typography";
import layout from "./foundation/layout";
import focus from "./foundation/focus";
import { spaces } from "./foundation/spaces";
import radius from "./foundation/radius";
import { expandVariants, normalizeStyles } from "./utils";
export var theme = {
    mq: mq,
    spaces: spaces,
    viewportsArray: viewportsArray,
    colors: colors,
    mediaQueries: mediaQueries,
    multipliers: multipliers,
    breakpoints: breakpoints,
    fonts: fonts,
    buttons: buttons,
    typography: typography,
    animation: animation,
    layout: layout,
    focus: focus,
    normalizeStyles: normalizeStyles,
    expandVariants: expandVariants,
    disableScaling: false,
    radius: radius
};
